import { createSelector } from 'reselect';

const orderedEventIds = state => state.events.events.orderedIds;
const eventsById = state => state.events.events.byId;
const chartsByEventId = state => state.seatingChart.byEventId;

export const getOrderedCharts = createSelector(
  orderedEventIds,
  chartsByEventId,
  (orderedEvtIds, chartsById) => {
    const chartKeys = chartsById ? Object.keys(chartsById) : [];
    return orderedEvtIds
      .filter(id => chartKeys.indexOf(id.toString()) > -1)
      .map(id => chartsById[id]);
  }
);

const getOrderedEvents = createSelector(orderedEventIds, eventsById, (orderedIds, events) =>
  orderedIds.map(eventId => events[eventId])
);

export const getEventFacetList = createSelector(getOrderedEvents, orderedEvents =>
  orderedEvents.map(event => ({
    label: event.name,
    value: {
      name: event.name,
      event_id: event.id,
    },
  }))
);

export const getChartlessEventsFacetList = createSelector(
  getOrderedEvents,
  chartsByEventId,
  (events, chartsByEvtId) => {
    const chartKeys = chartsByEvtId ? Object.keys(chartsByEvtId) : [];
    return events
      .filter(event => chartKeys.indexOf(event.id.toString()) === -1)
      .map(event => ({
        label: event.name,
        value: {
          name: event.name,
          event_id: event.id,
        },
      }));
  }
);



// WEBPACK FOOTER //
// ./src/selectors/seatingchart/seatingListSelector.js